import React from 'react';
import { useSelector } from 'react-redux';
import { useActions as profileHooks } from '@src/containers/ProfileVenue/hooks/useActions';
import { getMappedPacks } from '@src/containers/ProfileVenue/selectors/getMappedPacks';

import ProfilePack from '..';

const ProfilePackCVenueProfile = () => {
	const { setActivePack } = profileHooks();
	const items = useSelector(getMappedPacks);

	const handleClick = React.useCallback(
		(_, item) => {
			setActivePack({ id: item.id });
		},
		[setActivePack],
	);

	return (
		<ProfilePack
			items={items}
			onClick={handleClick}
			isOpen={items.length < 4}
		/>
	);
};

export default ProfilePackCVenueProfile;
